import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-financial-result-values',
  templateUrl: './financial-result-values.component.html',
  styleUrls: ['./financial-result-values.component.css']
})
export class FinancialResultValuesComponent implements OnInit {

  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();
  selectItem: any = [
    { label: 'Regime de competência', value: 1 },
    { label: 'Regime de caixa', value: 2 }
  ]
  itemSelected: any = 1;

  branchSelected: any;
  itemList: any = {};
  itemListResult: any = {};
  loading: boolean = true;
  inValue: boolean = false;
  errorApi: boolean = false;
  message : string = "";
  controller: any = new AbortController();

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  changeEventSelect(item: any) {
    this.loading = true;
    if (item == 1) {
      this.itemSelected = 1;
      this.resultValuesInformation()
    } else {
      this.itemSelected = 2;
      this.resultValuesInformation()
    }
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.branchSelected = item;
    this.changeEventSelect(1);
  }

  async resultValuesInformation() {
    try{
      let result = await this.api.postFinancialResult(this.branchSelected.dataMin, this.branchSelected.dataMax, this.branchSelected.branch, this.itemSelected).toPromise();
      if (result.dataRow.length != 0){
        this.inValue = true;
        for (let i = 0; i < result.dataRow.length; i++)
          result.dataRow[i].value = parseFloat(result.dataRow[i].value).toLocaleString('pt-br', {minimumFractionDigits: 2});
        this.itemListResult = result.dataRow[0];
        this.itemList = result.dataRow;
        this.itemList.shift();
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINANCIAL_INCOME_STATEMENT;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_FINANCIAL_INCOME_STATEMENT);
        this.errorApi = true;
      }
    } catch (ex: any){
      this.loading = false;
      this.errorApi = true;
      this.message = ex.error[0].message;
      this.formatErrorMensagem(ex.error[0].message);
    } finally {
      if (!this.inValue) {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_FINANCIAL_INCOME_STATEMENT;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_FINANCIAL_INCOME_STATEMENT);
      }   
      this.loading = false;
    }
  }
  
  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-income-statement \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
